(() => {
  'use strict';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const q = (selector, scope = document) => scope.querySelector(selector);


  document.addEventListener('click', (event) => {
    const scrollButton = event.target.closest('[data-tsc-scroll-config]');
    if (scrollButton) {
      event.preventDefault();
      const target = q('[data-ppc-submit]') || q('[data-pet-portrait-configurator]') || q('.product-information');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  function initStickyCta() {
    const sticky = q('[data-tsc-mobile-cta]');
    if (!sticky) return;
    if (q('[data-ts-mobile-purchase]') && q('pet-portrait-configurator')) {
      sticky.remove();
      return;
    }
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    sticky.hidden = false;
    const button = q('button', sticky);
    const setVisible = (visible) => {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (button) button.tabIndex = visible ? 0 : -1;
    };
    setVisible(false);

    const target = q('[data-ppc-submit]') || q('pet-portrait-configurator') || q('.product-information');
    if (!target || !('IntersectionObserver' in window)) {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && window.scrollY > target.getBoundingClientRect().top + window.scrollY);
    }, { rootMargin: '0px 0px -15% 0px', threshold: .05 });
    observer.observe(target);
  }

  function localizeThemeMenus() {
    const labels = new Map([
      ['Home', 'Home'],
      ['Catalog', 'Shop'],
      ['Contact', 'Contact'],
      ['Search', 'Search'],
      ['Orders', 'Orders'],
      ['Profile', 'Profile']
    ]);

    document.querySelectorAll('header a, header button, footer a, .footer-utilities a').forEach((element) => {
      const current = element.textContent.trim();
      if (labels.has(current)) element.textContent = labels.get(current);
    });

    const search = q('header button[aria-label="Search"]');
    const account = q('header button[aria-label="Account"]');
    const cart = q('header a[aria-label="Cart"]');
    if (search) search.setAttribute('aria-label', 'Search');
    if (account) account.setAttribute('aria-label', 'Account');
    if (cart) cart.setAttribute('aria-label', 'Cart');
  }

  function localizeCookieConsent() {
    const dialog = q('[role="alertdialog"]');
    if (!dialog) return;
    const heading = q('h2', dialog);
    if (heading && heading.textContent.trim() === 'Cookie consent') heading.textContent = 'Cookie preferences';

    dialog.querySelectorAll('button').forEach((button) => {
      const labels = { 'Manage preferences': 'Manage preferences', Accept: 'Accept', Decline: 'Decline' };
      const current = button.textContent.trim();
      if (labels[current]) button.textContent = labels[current];
    });

    const paragraph = q('p', dialog);
    if (paragraph && paragraph.textContent.trim().startsWith('We and our partners')) {
      const policy = q('a', paragraph);
      const policyHref = policy ? policy.href : '/policies/privacy-policy';
      paragraph.textContent = 'We and our partners, including Shopify, use cookies to personalize your shopping experience, support advertising and analyze site usage. Where required, we ask for your consent. Learn more in our ';
      const policyLink = document.createElement('a');
      policyLink.href = policyHref;
      policyLink.textContent = 'privacy policy';
      paragraph.append(policyLink, '.');
    }
  }

  function init() {
    initStickyCta();
    localizeThemeMenus();
    localizeCookieConsent();
    const header = q('header');
    if (header && 'MutationObserver' in window) {
      const observer = new MutationObserver(localizeThemeMenus);
      observer.observe(header, { childList: true, subtree: true });
      window.setTimeout(() => observer.disconnect(), 5000);
    }
    window.setTimeout(localizeThemeMenus, 700);
    window.setTimeout(localizeThemeMenus, 1800);
    window.setTimeout(localizeCookieConsent, 700);
    window.setTimeout(localizeCookieConsent, 1800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
